import { useEffect } from 'react';

const useNiceCXOneChat = (environment) => {


    useEffect(() => {

        if (!environment || window.CXoneDfo || environment.flags?.isLegacyChatEnabled || !environment.flags?.isWebChatEnabled) {
            return () => {};
        }

        const {
            links: {
                CHAT_TEMPLATE_LOGIN_EN,
                CHAT_TEMPLATE_LOGIN_ES,
                CHAT_TEMPLATE_NOT_LOGIN_EN,
                CHAT_TEMPLATE_NOT_LOGIN_ES,
                CHAT_ENTRYPOINT,
                CHAT_INIT
            },
            flags: {
                isWebChatEnabled,
                isWebChatEnglishEnabled,
                isWebChatSpanishEnabled
            },
            impersonation,
            impersonationDetails,
            language,
            user
        } = environment;

        const getConfigLanguage = () => {
            if(isWebChatEnabled && isWebChatEnglishEnabled && isWebChatSpanishEnabled) {
                return language;
            } else if(isWebChatEnabled && isWebChatEnglishEnabled) {
                return 'en';
            } else if(isWebChatEnabled && isWebChatSpanishEnabled) {
                return 'es';
            } else {
                return 'en';
            }
        };

        const getTemplateNumber = (language, isLogin) => {
            if(isLogin) {
                switch (language) {
                    case 'en':
                        return CHAT_TEMPLATE_LOGIN_EN;        
                    case 'es':
                        return CHAT_TEMPLATE_LOGIN_ES;
                }
            } else {
                switch (language) {
                    case 'en':
                        return CHAT_TEMPLATE_NOT_LOGIN_EN;
                    case 'es':
                        return CHAT_TEMPLATE_NOT_LOGIN_ES;
                }
            }
        };

        window.CXoneDfo = 'cxone';
        window.cxone = window.cxone || function () {
            (window.cxone.q = window.cxone.q || []).push(arguments);
        };

        window.cxone.u = 'https://web-modules-de-na1.niceincontact.com/loader/1/loader.js';

        const script = document.createElement('script');
        script.type = 'module';
        script.src = `${window.cxone.u}?${Math.round(Date.now() / 1e3 / 3600)}`;

        document.head.appendChild(script);

        script.onload = () => {

            const configLanguage = getConfigLanguage();
            const params = {};
            let userInfo = {};
            const uid = new URLSearchParams(window.location.search).get('u');
            const templateId = getTemplateNumber(configLanguage, !!user);
            
            window.cxone('init', CHAT_INIT, { rulesEngine: false, analyticsEvents: false });

            if(uid) {
                window.cxone('guide', 'init');
                window.cxone('guide','hidePreSurvey', '.');
                window.cxone('guide', 'startChatEntrypoint', CHAT_ENTRYPOINT); //use pointOfContact
                window.cxone('chat','setCaseCustomField', 'dynamic_data', `u=${uid}`);
            } else {
                window.cxone('guide', 'init', templateId);// use TemplateId, template contains pointOfContact, you launch pointOfContact directly or template directly 
                window.cxone('guide', 'openMenu');
                window.cxone('chat','setCaseCustomField', 'landingpage', window.location.href);
                window.cxone('chat','setCaseCustomField', 'language', configLanguage);
                if(user) { 
                    let capUrl, fullName, userId, activeModuleName, activeModuleId, externalHouseholdCaseId, impersonatedUserType, impersonatedUsername;
                    capUrl = `${window.location.host}/cap/consumer/view/${user.encryptedUserName}`;
                    fullName = impersonation ? `${impersonationDetails.firstName} ${impersonationDetails.lastName}` : `${user.firstName} ${user.lastName}`; 
                    userId = impersonation ? impersonationDetails.userId : user.userId;
                    activeModuleName = user.activeModuleName;
                    activeModuleId = user.activeModuleId;
                    externalHouseholdCaseId = impersonation ? impersonationDetails.externalHouseholdCaseId : user.externalHouseholdCaseId; 
                    impersonatedUserType = impersonation ? user.role : null;
                    impersonatedUsername = impersonation ? user.userName : null;
                    const username = sessionStorage.getItem('householdEmail') || null;
                    let ani = sessionStorage.getItem('householdPhone') || null;

                    if (ani !== null) {
                        ani = ani.slice(0,10).padStart(10, '0');
                    }

                    const userInfo = {
                        'UserID': userId,
                        'activeModuleName':  activeModuleName,
                        'activeModuleID': activeModuleId,
                        'fullName':  fullName,
                        'externalHouseholdCaseID': externalHouseholdCaseId,
                        'capUrl': capUrl,
                        'isSessionImpersonated': impersonation,
                        'impersonatedUserType': impersonatedUserType,
                        'impersonatedUsername': impersonatedUsername,
                        'ani': ani,
                        'username': username                
                    };

                    window.cxone('chat','setCaseCustomField', 'dynamic_data', JSON.stringify(userInfo));    
                    window.cxone('chat','setCaseCustomField', 'customer_name', fullName);            
                }
                                     
            }

            script.onerror = () => {
                console.error('CXoneChat script failed to load.');
            };
        };

        return () => {
            document.head.removeChild(script);
        };
    }, [ environment ]);
  
};

export default useNiceCXOneChat;